import { i18nProvider } from "@trumpf/ux.i18n";
import { h, Host, forceUpdate } from "@stencil/core";
import { getNotificationProvider } from "../../apis/notifications";
import { isDefined } from "../../utils/type-check";
import { createNotificationCluster, getClusterName } from "./utils";
const baseClass = "uxc-app-notification-list";
export class AppNotificationList {
    constructor() {
        this.notificationSubscriberId = "";
        this.i18nSubscriberId = "";
        this.renderNotificationItem = (data) => {
            return (h("li", { key: `${data.id}`, class: `${baseClass}__list-item` }, h("ux-notification-item", { source: data.sourceName, headline: data.subject, createdAt: `${data.timestamp}`, dateFormat: this.dateFormat, timeFormat: this.timeFormat, severity: data.severity, type: "Overview" }, h("span", { slot: "message" }, data.message))));
        };
        this.renderError = (err) => {
            const { t } = i18nProvider;
            switch (err.status) {
                case 401:
                    return t("notifications.error.unauthorized", "Unauthorized");
                default:
                    return err.message || t("notifications.error.general");
            }
        };
        this.dateFormat = "YYYY-MM-DD";
        this.timeFormat = "HH:mm:ss";
    }
    connectedCallback() {
        this.notificationSubscriberId = getNotificationProvider().subscribe(() => forceUpdate(this));
        this.i18nSubscriberId = i18nProvider.subscribe(() => forceUpdate(this));
    }
    disconnectedCallback() {
        i18nProvider.unsubscribe(this.i18nSubscriberId);
        getNotificationProvider().unsubscribe(this.notificationSubscriberId);
    }
    render() {
        const { t } = i18nProvider;
        const { notifications, error, pending, loadMore } = getNotificationProvider();
        const hasNotifications = notifications.length > 0;
        const cluster = createNotificationCluster(notifications);
        return (h(Host, { key: '7788bfdb9c3526d80494035d70b641a65cd2de0a', class: {
                [`${baseClass}`]: true
            } }, hasNotifications &&
            Object.entries(cluster).map(([clusterName, notifications]) => (h("div", { key: clusterName, class: `${baseClass}__cluster` }, h("header", { class: `${baseClass}__list-header` }, getClusterName(clusterName)), h("ul", { class: `${baseClass}__list` }, notifications.map(this.renderNotificationItem))))), h("div", { key: 'd0e5836edc45f93ec3b7a4c28caa0b4798dd0128', class: `${baseClass}__list-footer` }, pending && h("div", { key: '7721371218d95823bd52a1962b51b75cf6bd88e2', class: "ux-horizontal-loader" }), !pending && hasNotifications && loadMore && (h("div", { key: 'd12533cecb4a2f8129b5da3b3ba1a465fd618010', class: `${baseClass}__load-more` }, h("ux-button", { key: '86a57e671daf813530b346e5bd9e4451f147032d', onClick: loadMore }, t("notifications.button.loadMore")))), !pending && !hasNotifications && !isDefined(error) && (h("div", { key: '44964707a04c421c1f2e0321d8e1e3069e94617e', class: `${baseClass}__msg--info` }, t("notifications.info.noNotification", "No notifications"))), !pending && !hasNotifications && isDefined(error) && (h("div", { key: 'd48b7b2631115b5f885ae5f9b653782ed2b0594b', class: `${baseClass}__msg--error` }, this.renderError(error))))));
    }
    static get is() { return "uxc-app-notification-list"; }
    static get originalStyleUrls() {
        return {
            "$": ["app-notification-list.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["app-notification-list.css"]
        };
    }
    static get properties() {
        return {
            "dateFormat": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "date format for notifications"
                },
                "attribute": "date-format",
                "reflect": false,
                "defaultValue": "\"YYYY-MM-DD\""
            },
            "timeFormat": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "time format for notifications"
                },
                "attribute": "time-format",
                "reflect": false,
                "defaultValue": "\"HH:mm:ss\""
            }
        };
    }
    static get elementRef() { return "element"; }
}
//# sourceMappingURL=app-notification-list.js.map
